export const UPDATE_VERSION = "UPDATE_VERSION"

export const updateVersion = (version) => dispatch => {
    return dispatch({ type: UPDATE_VERSION, version });
}
